var _defs, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_175880",
    "data-name": "Group 175880",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.202,
    y1: 0.466,
    x2: 1.839,
    y2: 0.597,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ef93e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ff9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.018,
    y1: 0.375,
    x2: 1.107,
    y2: 0.547,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ef93e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68b5ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172746",
    "data-name": "Group 172746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103505",
    "data-name": "Path 103505",
    d: "M130.224,218.221a8.336,8.336,0,1,1,.033-16.089,10.936,10.936,0,0,1,2.432-1.686,11.927,11.927,0,0,0-17.283,15.585l-1.659,6.205,6.191-1.663a11.895,11.895,0,0,0,12.717-.651A10.947,10.947,0,0,1,130.224,218.221Z",
    transform: "translate(-113.747 -198.236)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103506",
    "data-name": "Path 103506",
    d: "M220.7,233.742l-1.26-4.714a9.041,9.041,0,1,0-3.443,3.451Zm-10.867-2.832a6.333,6.333,0,1,1,6.319-6.333A6.326,6.326,0,0,1,209.829,230.91Z",
    transform: "translate(-187.696 -212.622)",
    fill: "url(#linear-gradient-2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103507",
    "data-name": "Path 103507",
    d: "M263.707,265.608a.8.8,0,1,0-.8.805A.8.8,0,0,0,263.707,265.608Z",
    transform: "translate(-237.348 -253.672)",
    fill: "#ff9f0a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103508",
    "data-name": "Path 103508",
    d: "M221.073,263.367a1.252,1.252,0,1,0-1.252,1.255A1.254,1.254,0,0,0,221.073,263.367Z",
    transform: "translate(-201.079 -251.431)",
    fill: "#ff9f0a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103509",
    "data-name": "Path 103509",
    d: "M169.845,260.183a1.89,1.89,0,1,0-1.891,1.895A1.893,1.893,0,0,0,169.845,260.183Z",
    transform: "translate(-157.335 -248.246)",
    fill: "#ff9f0a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebar-logo.2aa6c4cb6ddf43ca86f5798fc86c1026.svg";
export { ForwardRef as ReactComponent };